import { getSecureLocalItem } from "../utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const getDashboardStats = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/dashboardStats", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesOverview = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/salesOverview", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRecentOrders = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/recentOrders", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTopSellingProducts = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/topSellingProducts", config);
    return response;
  } catch (error) {
    throw error;
  }
};